var module = angular.module('meternet.charts.services', [
    'meternet.charts.gauge.services',
    'meternet.charts.prepaid.services',
    'meternet.dashboard.controllers.eventsAckWidget'
]);
